import { Form, FormAPI, Team, TeamAPI } from '@brg/api';
import { useAssociatedProfile } from '@brg/auth';
import { useCallback, useEffect, useState } from 'react';
import urlApi from 'shared/actions/urlApi';
import { AppTester } from 'supporting';

export const useTeamForms = (id: string, date: number) => {
    const [forms, setForms] = useState<Form<'Global'>[]>([]);
    
    const fetchForms = (id: string) => {
        //@ts-ignore
        FormAPI.GetList({ teamIds: [id], limit: 100, page: 1 })
        .then((r) => {
            return r.json()
        })
        //@ts-ignore
        .then((r) => setForms(r?.data))
    } 

    useEffect(() => {
        if (!!id?.length) {
            fetchForms(id)
        } 
    } , [id, date])

    if (!id?.length) {
        return []
    }

    return forms;
}import { Form, FormAPI, Team, TeamAPI } from '@brg/api';
import { useAssociatedProfile } from '@brg/auth';
import { useCallback, useEffect, useState } from 'react';
import urlApi from 'shared/actions/urlApi';
import { AppTester } from 'supporting';

export const useTeamForms = (id: string, date: number) => {
    const [forms, setForms] = useState<Form<'Global'>[]>([]);
    
    const fetchForms = (id: string) => {
        //@ts-ignore
        FormAPI.GetList({ teamIds: [id], limit: 100, page: 1 })
        .then((r) => {
            return r.json()
        })
        //@ts-ignore
        .then((r) => setForms(r?.data))
    } 

    useEffect(() => {
        if (!!id?.length) {
            fetchForms(id)
        } 
    } , [id, date])

    if (!id?.length) {
        return []
    }

    return forms;
}